"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Route", {
  enumerable: true,
  get: function get() {
    return _route["default"];
  }
});
Object.defineProperty(exports, "PrivateRoute", {
  enumerable: true,
  get: function get() {
    return _privateRoute["default"];
  }
});
Object.defineProperty(exports, "PublicRoute", {
  enumerable: true,
  get: function get() {
    return _publicRoute["default"];
  }
});
Object.defineProperty(exports, "AnalyticsContext", {
  enumerable: true,
  get: function get() {
    return _AnalyticsContext["default"];
  }
});
exports.Reducer = exports["default"] = void 0;

var _baseRouter = _interopRequireDefault(require("./components/base-router"));

var _route = _interopRequireDefault(require("./components/route"));

var _store = _interopRequireDefault(require("./store"));

var _privateRoute = _interopRequireDefault(require("./components/private-route"));

var _publicRoute = _interopRequireDefault(require("./components/public-route"));

var _AnalyticsContext = _interopRequireDefault(require("./contexts/AnalyticsContext"));

var Reducer = function Reducer(reducerObj) {
  reducerObj.router = _store["default"];
};

exports.Reducer = Reducer;
var _default = _baseRouter["default"];
exports["default"] = _default;